let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gjwKc")).then(() => parcelRequire('2d7eO'));